import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatCurrency } from "helpers/utils";
import type { PedidosLojaResumo } from "hooks/usePedidosLoja";
import { PEDIDOS_ACCENT } from "./pedidos.theme";

type PedidosKpiCardsProps = {
  resumo: PedidosLojaResumo | null;
  totalFiltrado: number;
  isFiltered: boolean;
};

function StatMini({
  label,
  value,
  accent,
}: {
  label: string;
  value: string | number;
  accent?: boolean;
}) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: accent ? "rgba(249, 96, 48, 0.3)" : "grey.200",
        bgcolor: accent ? "rgba(249, 96, 48, 0.04)" : "background.paper",
        height: "100%",
      }}
    >
      <Typography variant="h4" fontWeight="bold" color={accent ? PEDIDOS_ACCENT : "text.primary"}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export default function PedidosKpiCards({
  resumo,
  totalFiltrado,
  isFiltered,
}: PedidosKpiCardsProps) {
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} sm={4}>
        <StatMini
          label={isFiltered ? "Pedidos no filtro" : "Total de pedidos"}
          value={totalFiltrado}
          accent
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StatMini label="Receita no filtro" value={formatCurrency(resumo?.receitaTotal ?? 0)} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StatMini label="Ticket médio" value={formatCurrency(resumo?.ticketMedio ?? 0)} />
      </Grid>
    </Grid>
  );
}
